export const Dodger_Blue = {name : 'Dodger_Blue' ,value : '#4CADFE'};
export const Blue_Ribbon = {name : 'Blue_Ribbon',value : '#0071F5'};
export const Blue_Ribbon50 = {name : 'Blue_Ribbon 50% Opacity' ,value : 'rgba(0, 113, 245, 0.5)'};
export const Blue_Ribbon35 = {name : 'Blue_Ribbon 35% Opacity' ,value : 'rgba(0, 113, 245, 0.35)'};
export const Solitude = {name : 'Solitude' ,value : '#E8F4FE'};
export const Keppel = {name : 'Keppel' ,value : '#40B98E'};
export const  Bright_Turquoise = {name : 'Bright_Turquoise' ,value : '#0DDBB5'};
export const Polar = {name : 'Polar' ,value : '#DBF6F1'};
export const French_Rose = {name :'French_Rose' ,value : '#f24986'};
export const Hot_Pink = {name : 'Hot_Pink' ,value : '#FF66A0'};
export const Carousel_Pink = {name :'Carousel_Pink' ,value : '#FBE6EE'};
export const Crusta = {name : 'Crusta' ,value : '#FD8032'};
export const Sunglow = {name : 'Sunglow' ,value : '#FFD232'};
export const Half_Dutch_White = { name : 'Half_Dutch_White' ,value : '#FEF7DE'};
export const Mirage = { name : 'Mirage' ,value : '#151922'};
export const  Black80 = {name : 'Black 80%Opacity' ,value : 'rgba(0, 0, 0, 0.8)'};
export const Black70 = {name : 'Black 70% Opacity'  ,value : 'rgba(0, 0, 0, 0.7)'};
export const Black60 = {name : 'Black 60% Opacity'  ,value : 'rgba(0, 0, 0, 0.6)'};
export const Black50 = {name : 'Black 50% Opacity'  ,value : 'rgba(0, 0, 0, 0.5)'};
export const Gray = {name : 'Gray' ,value : '#7F7F7F'};
export const Black40 = {name : 'Black 40% Opacity' ,value : 'rgba(0, 0, 0, 0.4)'};
export const Dusty_Gray = {name : 'Dusty_Gray' ,value : '#999999'};
export const Black30 = {name : 'Black 30% Opacity' ,value : 'rgba(0, 0, 0, 0.3)'};
export const Black25 = {name : 'Black 25% Opacity' ,value : 'rgba(0, 0, 0, 0.25)'};
export const Black20 = {name : 'Black 20% Opacity' ,value : 'rgba(0, 0, 0, 0.20)'};
export const Black15 = {name : 'Black 15% Opacity' ,value : 'rgba(0, 0, 0, 0.15)'};
export const Black10 = {name : 'Black 10% Opacity' ,value : 'rgba(0, 0, 0, 0.1)'};
export const Black7 = {name : 'Black 7% Opacity' ,value : 'rgba(0, 0, 0, 0.07)'};
export const Black4 = {name : 'Black 4% Opacity' ,value : 'rgba(0, 0, 0, 0.04)'};
export const Porcelain = {name : 'Porcelain' ,value: '#F3F4F5'};
export const Sunset_Orange = {name : 'Sunset Orange' ,value: '#FB4444'};
export const Azure_Radiance = {name : 'Azure Radiance' ,value: '#127DFB'};
export const Curious_Blue = {name : 'Curious Blue' ,value: '#3190E0'};
export const Dodger_Blue50 = {name : 'Dodger Blue 50% Opacity' ,value: 'rgba(66, 153, 255, 0.5)'};
export const Dodger_Blue35 = {name : 'Dodger Blue 35% Opacity' ,value: 'rgba(66, 153, 255, 0.35)'};
export const Dodger_Blue10 = {name : 'Dodger Blue 10% Opacity' ,value: 'rgba(66, 153, 255, 0.10)'};
export const Gossamer = {name : 'Gossamer' ,value: '#0DA26D'};
export const Persian_Green = {name : 'Persian Green' ,value: '#00B997'};
export const Keppel25 = {name : 'Keppel25' ,value : 'rgba(64, 185, 142, 0.25)'};
export const Cerise_Red = {name : 'Cerise Red' ,value : '#DC2B6B'};
export const Cranberry = {name : 'Cranberry' ,value : '#DB4A81'};
export const French_Rose15 = {name : 'French_Rose15' ,value : 'rgba(242, 73, 134, 0.15)'};
export const Hot_Cinnamon = {name : 'Hot Cinnamon' ,value : '#DB651B'};
export const Crusta15 = {name : 'Crusta 15' ,value : 'rgba(253, 128, 50, 0.15)'};
export const Kournikova = {name : 'Kournikova' ,value : '#FFE174'};
export const Fuel_Yellow = {name : 'Fuel Yellow' ,value : '#E8BC21'};
export const White = {name : 'White' ,value : '#FFFFFF'};
export const White90 = {name : 'White90' ,value : 'rgba(255, 255, 255, 0.9)'};
export const White80 = {name : 'White80' ,value : 'rgba(255, 255, 255, 0.8)'};
export const White70 = {name : 'White70' ,value : 'rgba(255, 255, 255, 0.7)'};
export const White60 = {name : 'White60' ,value : 'rgba(255, 255, 255, 0.6)'};
export const White50 = {name : 'White50' ,value : 'rgba(255, 255, 255, 0.5)'};
export const White40 = {name : 'White40' ,value : 'rgba(255, 255, 255, 0.4)'};
export const White30 = {name : 'White30' ,value : 'rgba(255, 255, 255, 0.3)'};
export const White25 = {name : 'White25' ,value : 'rgba(255, 255, 255, 0.25)'};
export const White20 = {name : 'White20' ,value : 'rgba(255, 255, 255, 0.20)'};
export const White15 = {name : 'White15' ,value : 'rgba(255, 255, 255, 0.15)'};
export const White10 = {name : 'White10' ,value : 'rgba(255, 255, 255, 0.10)'};
export const White4 = {name : 'White4' ,value : 'rgba(255, 255, 255, 0.04)'};
export const Ebony_Clay = {name : 'Ebony Clay' ,value : '#222835'};

const colors = [
    Blue_Ribbon,
    Dodger_Blue,
    Blue_Ribbon50,
    Blue_Ribbon35,
    Solitude,
    Keppel,
    Bright_Turquoise,
    Polar,
    French_Rose,
    Hot_Pink,
    Carousel_Pink,
    Crusta,
    Sunglow,
    Half_Dutch_White,
    Mirage,
    Black80,
    Black70,
    Black60,
    Black50,
    Gray,
    Black40,
    Dusty_Gray,
    Black30,
    Black25,
    Black20,
    Black15,
    Black10,
    Black7,
    Black4,
    Porcelain,
    Sunset_Orange,
    Azure_Radiance,
    Curious_Blue,
    Dodger_Blue50,
    Dodger_Blue35,
    Dodger_Blue10,
    Gossamer,
    Persian_Green,
    Keppel25,
    Cerise_Red,
    Cranberry,
    French_Rose15,
    Hot_Cinnamon,
    Crusta15,
    Kournikova,
    Fuel_Yellow,
    White,
    White90,
    White80,
    White70,
    White60,
    White50,
    White40,
    White30,
    White25,
    White20,
    White15,
    White10,
    White4,
    Ebony_Clay,
]


export default colors;
